import { Outlet } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { ReferralLinkDialogs } from '~/components/ReferralLinkDialogs';
import { ReferralLinkedToast } from './shared/ReferralLinkedToast';
import type { ISignUpFormValues } from './types';

const DEFAULT_VALUES: ISignUpFormValues = {
  firstName: '',
  lastName: '',
  mobileNumber: '',
  officeName: '',
  officeAddress: '',
  officeType: '',
  officeSpecialty: '',
  timePerPatient: { rdh: '', da: '', ddn: '' },
  assistedHygiene: '',
  parkingInfo: { type: '', isFree: '', cost: '', unit: '' },
  softwares: [],
  insurances: [],
  workerType: '',
  psaAccepted: false,
};

export const SignUpLayout = () => {
  const methods = useForm<ISignUpFormValues>({
    mode: 'onSubmit',
    defaultValues: DEFAULT_VALUES,
  });

  return (
    <FormProvider {...methods}>
      {/*
        Hosted here, not in the form that earns it: a successful sign-up
        navigates away from `SignUpPage`, which is a sibling of this layout
        rather than a child, so a toast rendered there is unmounted before it
        can be seen. See `ReferralLinkedToast`.
      */}
      <ReferralLinkedToast />
      {/*
        GOTU-9922: an office that has not finished the wizard is signed in, so
        `ReferralLinkRedirect` lands a referral tap here rather than on the
        dashboard, carrying the same navigation state.
      */}
      <ReferralLinkDialogs />
      <Outlet />
    </FormProvider>
  );
};
